import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useHeaderStyles = makeStyles<Theme, { defaultHeight?: number }>(() => ({
  pageHeader: {
    color: '#fff',
    paddingTop: '3rem',
    paddingBottom: '3rem',
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: ({ defaultHeight }) => (typeof defaultHeight === 'number' ? `${defaultHeight}px` : 'auto')
  },
  title: {
    marginBottom: '5px'
  },
  subtitle: {
    fontSize: '1.175rem',
    color: 'rgba(255, 255, 255, 0.77)',
    marginBottom: '5px',
    minHeight: '1.85rem'
  },
  status: {
    fontSize: '17px',
    marginBottom: '5px'
  },
  info: {
    fontSize: '14px',
    marginBottom: '1rem'
  },
  address: {
    lineHeight: 0.8
  }
}));
